import React from 'react';
import {
  hasAnyPermission,
  isAdmin,
  isSuperAdmin,
  isSuperAdminOnly,
  logoutHelper,
} from '../../utils';
import { Navigate } from 'react-router';
import { RoutePermissions } from '../../constants/routePermissions';

interface ProtectedRouteProps {
  permission: RoutePermissions['permissions'];
  children: React.ReactNode;
  onlyNetworkOwner?: boolean;
}

const ProtectedRoute = ({
  permission,
  children,
  onlyNetworkOwner,
}: ProtectedRouteProps): React.JSX.Element => {
  const isAuthenticated = !!localStorage.getItem('loggedIn');
  const user = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user') as string)
    : null;
  const isNetworkOwner = isSuperAdmin(true);
  // On-boarding is owned by network owners; admins may update their own
  // organization and super admins may update a selected organization.
  const hasAccess = onlyNetworkOwner
    ? isNetworkOwner || isAdmin() || isSuperAdminOnly()
    : hasAnyPermission(permission);
  const onboardingCompleted = user?.completedOnboarding;

  if (isNetworkOwner && !onboardingCompleted && !onlyNetworkOwner) {
    return <Navigate to="/on-boarding" replace />;
  }

  if (isAuthenticated && hasAccess) {
    return <>{children}</>;
  }

  logoutHelper();
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
